import React from 'react'
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic'
import SectionHeading from '../../../components/Heading'
import { parkinglots } from '../../../utils/redux/config/parking'
import PageLayout from '../../../components/layouts/PageLayout'
import InteractiveMap from '../../../components/ImageMapper'
import { withNamespaces } from 'react-i18next'
import { translate } from '../../../utils/translate'

class View extends React.Component {
	constructor(props){
		super(props)
		this.imageWrapper = React.createRef()
		this.state = {
			interactiveMapWidth: 0
		}
	}

	componentDidMount () {
		this.setState({
			interactiveMapWidth: this.imageWrapper.current.offsetWidth
		})
	}

	render () {
		const { t } = this.props
		const translatedParkings = parkinglots.map(park => ({
			...park,
			type: translate(park.type),
			status: translate(park.status),
			...park.description ? { description: translate(park.description) } : {}
		}))
		const areasAB = [
			{ name: '5', number: '5', shape: 'rect', coords:[1667,429,1789,712] },
			{ name: '6', number: '6', shape: 'rect', coords:[1536,429,1665,712] },
			{ name: '7', number: '7', shape: 'rect', coords:[1351,346,1471,629] },
			{ name: '8', number: '8', shape: 'rect', coords:[1220,346,1347,629] },
			{ name: '9', number: '9', shape: 'rect', coords:[1036,269,1155,555] },
			{ name: '10', number: '10', shape: 'rect', coords:[909,269,1031,555] },
			{ name: '11', number: '11', shape: 'rect', coords:[257,283,542,399] },
			{ name: '12', number: '12', shape: 'rect', coords:[257,403,542,518] },
			{ name: '13', number: '13', shape: 'rect', coords:[231,565,520,691] },
			{ name: '14', number: '14', shape: 'rect', coords:[231,694,520,818] },
			{ name: '15', number: '15', shape: 'rect', coords:[227,866,519,988] },
			{ name: '16', number: '16', shape: 'rect', coords:[227,991,519,1118] },
			{ name: '17', number: '17', shape: 'rect', coords:[167,1164,455,1290] },
			{ name: '18', number: '18', shape: 'rect', coords:[167,1293,455,1418] },
			{ name: '19', number: '19', shape: 'rect', coords:[135,1475,427,1602] },
			{ name: '20', number: '20', shape: 'rect', coords:[135,1606,427,1731] },
			{ name: '21', number: '21', shape: 'rect', coords:[107,1772,400,1892] },
			{ name: '22', number: '22', shape: 'rect', coords:[107,1920,400,2037] },
			{ name: '23', number: '23', shape: 'rect', coords:[426,2004,554,2290] },
			{ name: '24', number: '24', shape: 'rect', coords:[593,2004,720,2290] },
			{ name: '25', number: '25', shape: 'rect', coords:[725,2004,861,2290] },
			{ name: '26', number: '26', shape: 'rect', coords:[900,2004,1029,2290] },
			{ name: '27', number: '27', shape: 'rect', coords:[1166,2291,1032,2003] },
			{ name: '28', number: '28', shape: 'rect', coords:[1375,2002,1229,2292] },
			{ name: '30', number: '30', shape: 'rect', coords:[1375,2002,1520,2292] },
			{ name: '32', number: '32', shape: 'rect', coords:[1582,1984,1792,2277] },
			{ name: '51', number: '51', shape: 'rect', coords:[1586,1373,1732,1666] },
			{ name: '53', number: '53', shape: 'rect', coords:[1287,1375,1430,1663] },
			{ name: '55', number: '55', shape: 'rect', coords:[895,1578,1183,1693] },
			{ name: '56', number: '56', shape: 'rect', coords:[927,966,1068,1251] },
			{ name: '56', number: '56', shape: 'rect', coords:[1280,968,1423,1256] },
			{ name: '60', number: '60', shape: 'rect', coords:[1586,1049,1729,1337] },
			{ name: "izba1", number: '1 A-B', coords: [756,164,883,197,880,337,721,291], type: 'basement', shape: "poly" },
			{ name: "izba2", number: '2 A-B', coords: [641,138,749,164,716,293,608,267], type: 'basement', shape: "poly" },
			{ name: "izba3", number: '3 A-B', coords: [454,86,631,130,601,259,513,231,433,220], type: 'basement', shape: "poly" },
			{ name: "izba4", number: '4 A-B', coords: [269,60,440,87,424,219,311,210,256,198], type: 'basement', shape: "poly" },
			{ name: "izba5", number: '5 A-B', coords: [67,2071,399,2071,399,2177,53,2177], type: 'basement', shape: "poly" },
			{ name: "izba6", number: '6 A-B', coords: [55,2186,403,2187,403,2311,166,2316], type: 'basement', shape: "poly" },
			{ name: "izba7", number: '7 A-B', coords: [753,1569,876,1670], type: 'basement', shape: "rect" },
			{ name: "izba8", number: '8 A-B', coords: [751,1459,871,1558], type: 'basement', shape: "rect" },
			{ name: "izba9", number: '9 A-B', coords: [790,1299,875,1451], type: 'basement', shape: "rect" },
			{ name: "izba10", number: '10 A-B', coords: [790,1129,871,1293], type: 'basement', shape: "rect" },
		]

		const areasCD = [
			{ name: '1', number: '1', shape: 'poly', coords: [981,350,930,534,1185,599,1236,417] },
			{ name: '2', number: '2', shape: 'poly', coords: [725,279,674,461,930,534,980,350] },
			{ name: '3', number: '3', shape: 'poly', coords: [473,235,474,500,663,500,662,235] },
			{ name: '4', number: '4', shape: 'poly', coords: [222,214,220,483,413,483,413,214] },
			{ name: '33', number: '33', shape: 'rect', coords: [209,1575,331,1833] },
			{ name: '34', number: '34', shape: 'rect', coords: [335,1575,453,1833] },
			{ name: '35', number: '35', shape: 'rect', coords: [520,1564,651,1831] },
			{ name: '37', number: '37', shape: 'rect', coords: [653,1563,787,1833] },
			{ name: '39', number: '39', shape: 'rect', coords: [863,1564,996,1829] },
			{ name: '41', number: '41', shape: 'rect', coords: [1045,1564,1174,1829] },
			{ name: '42', number: '42', shape: 'rect', coords: [1176,1564,1305,1829] },
			{ name: '43', number: '43', shape: 'rect', coords: [1365,1564,1494,1829] },
			{ name: '45', number: '45', shape: 'rect', coords: [1499,1566,1630,1829] },
			{ name: '47', number: '47', shape: 'rect', coords: [1674,1564,1863,1831] },
			{ name: '48', number: '48', shape: 'rect', coords: [833,985,1022,1250] },
			{ name: '49', number: '49', shape: 'rect', coords: [692,990,814,1257] },
			{ name: '50', number: '50', shape: 'rect', coords: [557,990,688,1255] },
			{ name: '62', number: '62', shape: 'rect', coords: [208,693,340,956] },
			{ name: '63', number: '63', shape: 'rect', coords: [347,693,478,956] },
			{ name: '64', number: '64', shape: 'rect', coords: [501,700,693,969] },
			{ name: '65', number: '65', shape: 'rect', coords: [769,700,898,965] },
			{ name: '66', number: '66', shape: 'rect', coords: [904,700,1033,965] },
			{ name: '67', number: '67', shape: 'rect', coords: [1052,794,1181,1066] },
			{ name: '68', number: '68', shape: 'rect', coords: [1185,924,1448,1057] },
			{ name: '69', number: '69', shape: 'rect', coords: [1186,795,1450,921] },
			{ name: '70', number: '70', shape: 'rect', coords: [1732,1020,1865,1287] },
		]

		const areasE = [
			{ name: "izba1E", number: '1 E', coords: [330,1097,705,1355], type: 'basement', shape: "rect" },
			{ name: "izba2E", number: '2 E', coords: [855,1353,1005,1352,1060,1445,1057,1618,853,1620], type: 'basement', shape: "poly" },
			{ name: "izba3E", number: '3 E', coords: [853,1636,1057,1894], type: 'basement', shape: "rect" },
			{ name: "izba4E", number: '4 E', coords: [857,1912,1055,2193], type: 'basement', shape: "rect" },
			{ name: "izba5E", number: '5 E', coords: [705,2504,1058,2654], type: 'basement', shape: "rect" },
			{ name: "izba6E", number: '6 E', coords: [705,2671,1062,2788], type: 'basement', shape: "rect" },
			{ name: "izba7E", number: '7 E', coords: [705,2807,1058,2929], type: 'basement', shape: "rect" },
			{ name: "izba8E", number: '8 E', coords: [574,2673,329,2931], type: 'basement', shape: "rect" },
			{ name: "izba9E", number: '9 E', coords: [541,1390,691,1599], type: 'basement', shape: "rect" }
		]

		return <PageLayout showBreadcrumbs>
			<BreadcrumbsItem to='/'>{t('general.home')}</BreadcrumbsItem>
			<BreadcrumbsItem to='/parking'>{t('general.parkingLots')}</BreadcrumbsItem>
			<div className='c-content'>
				<div className='o-wrapper'>
					<SectionHeading text={`${t('general.basement')} A-B`} />
					<div ref={this.imageWrapper} className='c-interactive-map__holder u-relative u-margin-bottom-large'>
						<InteractiveMap
							url='/img/floorplans/parkingAB.png'
							name='planABparking'
							areas={areasAB}
							width={this.state.interactiveMapWidth}
							imgWidth={2000}
							fillColor='rgba(247,233,210,0.7)'
							mapType='parking'
							mapArray={translatedParkings}/>
					</div>
					<SectionHeading text={`${t('general.basement')} C-D`} />
					<div ref={this.imageWrapper} className='c-interactive-map__holder u-relative u-margin-bottom-large'>
						<InteractiveMap
							url='/img/floorplans/parkingCD.png'
							name='planCDparking'
							areas={areasCD}
							width={this.state.interactiveMapWidth}
							imgWidth={2000}
							fillColor='rgba(247,233,210,0.7)'
							mapType='parking'
							mapArray={translatedParkings}
                            {...this.props}
                        />
					</div>
					<SectionHeading text={`${t('general.basement')} E`} />
					<div ref={this.imageWrapper} className='c-interactive-map__holder u-relative u-margin-bottom-large'>
						<InteractiveMap
							url='/img/floorplans/parkingE.png'
							name='planEparking'
							areas={areasE}
							width={this.state.interactiveMapWidth}
							imgWidth={2000}
							fillColor='rgba(247,233,210,0.7)'
							mapType='parking'
							mapArray={translatedParkings}
                            {...this.props}
                        />
					</div>
				</div>
			</div>
		</PageLayout>
	}
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/ParkingLots/components/View.js